import React, { Component } from "react";
import loadsStore from "../../../stores/loads-store";
import { ScaleLoader } from 'react-spinners'
import moment from 'moment';
import './index.css'
import DonutLoader from "../DonutLoader";

export default class Rigs extends Component {

    constructor(props) {
        super(props);

        this.state = {
            rigsDetails: {},
            loading: true
        };
    }

    componentDidMount() {
        let id = this.getParameterByName('id')
        if (id) {
            loadsStore.loadItems().then(response => {
                console.log(response, "867908787")
                let filteredObject = response.find(val => val._id == id)
                this.setState({ rigsDetails: filteredObject }, () => {
                    this.setState({ loading: false })
                })
            })
        }
    }
    isLoading() {
        return <DonutLoader isLoading={this.state.loading} addClass='sample1'/>
        // return (<div style={{ position: 'absolute', left: '48%', top: '40%', zIndex: '999999' }}>
        //     <div className='sweet-loading'>
        //         <ScaleLoader
        //             height={35}
        //             width={8}
        //             margin={'2px'}
        //             radius={2}
        //             color={'#123abc'}
        //             loading={this.state.loading}
        //         />
        //     </div>
        // </div>)
    }

    getParameterByName = (name) => {
        var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
        return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
    }

    render() {
        let { rigsDetails, loading } = this.state
        if (loading) {
            return this.isLoading()
        }
        return (
            <div className="mainContainer">
                <div className="itemContainer">
                    <h2>
                        Rig Details
                    </h2>
                    <div className="itemFlex">
                        <p>
                            Name
                        </p>
                        <p>
                            {rigsDetails.item}
                        </p>
                    </div>
                    <div className="borderMain" />


                    <div className="itemFlex">
                        <p>
                            Category
                        </p>
                        <p>
                            {rigsDetails.category}
                        </p>
                    </div>
                    <div className="borderMain" />


                    <div className="itemFlex">
                        <p>
                            Main
                        </p>
                        <p>
                            {rigsDetails.main}
                        </p>
                    </div>
                    <div className="borderMain" />

                    <div className="itemFlex">
                        <p>
                            Main Serial
                        </p>
                        <p>
                            {rigsDetails.mainSerial}
                        </p>
                    </div>

                    <div className="borderMain" />

                    <div className="itemFlex">
                        <p>
                            Container
                        </p>
                        <p>
                            {rigsDetails.container}
                        </p>
                    </div>
                    <div className="borderMain" />

                    <div className="itemFlex">
                        <p>
                            Container serial
	                    </p>
                        <p>
                            {rigsDetails.containerSerial}
                        </p>
                    </div>
                    <div className="borderMain" />

                    <div className="itemFlex">
                        <p>
                            Reserve
                        </p>
                        <p>
                            {rigsDetails.reserve}
                        </p>
                    </div>
                    <div className="borderMain" />

                    <div className="itemFlex">
                        <p>
                            Reserve Serial
                        </p>
                        <p>
                            {rigsDetails.reserveSerial}
                        </p>
                    </div>
                    <div className="borderMain" />

                    <div className="itemFlex">
                        <p>
                            Aad
                        </p>
                        <p>
                            {rigsDetails.aad}
                        </p>
                    </div>
                    <div className="borderMain" />

                    <div className="itemFlex">
                        <p>
                            Aad Serial
                        </p>
                        <p>
                            {rigsDetails.aadSerial}
                        </p>
                    </div>
                    <div className="borderMain" />

                    <div className="itemFlex">
                        <p>
                            Last Reserve Repack
                        </p>
                        <p>
                            {moment(rigsDetails.reserveRepackDate).format('DD-MM-YYYY')}
                        </p>
                    </div>
                    <div className="borderMain" />
                    <div className="itemFlex">
                        <p>
                            Sale price
                        </p>
                        <p>
                            (${rigsDetails.salePrice ? parseFloat(rigsDetails.salePrice).toFixed(2) : 0})
                        </p>
                    </div>
                    <div className="borderMain" />
                    <div className="itemFlex">
                        <p>
                            Rental price
                        </p>
                        <p>
                            (${rigsDetails.rentalPrice ? parseFloat(rigsDetails.rentalPrice).toFixed(2) : 0})
                        </p>
                    </div>
                    <div className="borderMain" />
                    <div className="itemFlex">
                        <p>
                            Day rental rate
                        </p>
                        <p>
                            (${rigsDetails.dayRentalRate ? parseFloat(rigsDetails.dayRentalRate).toFixed(2) : 0})
                        </p>
                    </div>
                    <div className="borderMain" />

                    <div className="itemFlex">
                        <p>
                            Packjob Pay
                        </p>
                        <p>
                            (${rigsDetails.packJobPay ? parseFloat(rigsDetails.packJobPay).toFixed(2) : 0})

                        </p>
                    </div>
                    <div className="borderMain" />

                    <div className="itemFlex">
                        <p>
                            Repack Pay
                        </p>
                        <p>
                            (${rigsDetails.reserveRepackPay ? parseFloat(rigsDetails.reserveRepackPay).toFixed(2) : 0})
                        </p>
                    </div>
                    <div className="borderMain" />
                </div>
            </div>
        );
    }
}